// extracted by mini-css-extract-plugin
export default {"root":"spidometr_root__pRaUD","svg":"spidometr_svg__5Q76g","header":"spidometr_header__PCOE7"};